/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { useAppStore } from "../../../appStore";
import { createSiteHyperlink } from "../Alerts/AlertsUtils/createSiteHyperlink";
import { createCameraHyperlink } from "../Alerts/AlertsUtils/createCameraHyperlink";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { SMTPTable } from "./SMTPTable";
import { LoadingSpinner } from "../../common/LoadingSpinner";
import { CircularProgress } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AlertsTableSMTP } from "./AlertsTableSMTP";
import { handleArrowButtonClickSMTP } from "./ClipsUtilities/handleArrowButtonClickSMTP";
import { SMTPPhotoSlider } from "./SMTPPhotoSwiper";
import { ShareClipUrlButton } from "./ShareClipUrlButton";
import { removeClipsIdParamsFromUrl } from "./ClipsUtilities/clipsUrlParams";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export const SMTPTab = ({ navBarCollapsed }: { navBarCollapsed: boolean }) => {
  const { userPermissions } = useAppStore();

  const {
    selectedRowSMTP,
    fetchingFilteredDataSMTP,
    loadingAdditionalDataSMTP,
    videoClipLoadingSMTP,
    smtpSite,
    smtpData,
    setSmtpData,
    setSelectedRowSMTP,
    setVideoClipLoadingSMTP,
    getVideoURLSMTP,
    smtpTableFilter,
  } = useClipsStore();

  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = React.useState("formatted_date");

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Calculate filtered data (same logic as in SMTPTable)
  const filteredData = React.useMemo(
    () =>
      smtpTableFilter === "alerts"
        ? smtpData.filter((row: any) => row.alerts && row.alerts.length > 0)
        : smtpTableFilter === "no_alerts"
        ? smtpData.filter((row: any) => !row.alerts || row.alerts.length === 0)
        : smtpData,
    [smtpData, smtpTableFilter]
  );

  return (
    <div
      className={
        navBarCollapsed
          ? userPermissions.sentinel || userPermissions.ailink
            ? "relative left-[75px] top-[150px] w-[600px]"
            : "relative left-[75px] top-[90px] w-[600px]"
          : userPermissions.sentinel || userPermissions.ailink
          ? "relative left-[150px] top-[150px] w-[600px]"
          : "relative left-[150px] top-[90px] w-[600px]"
      }
    >
      <p className="relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]">
        {smtpSite.site_name
          ? createSiteHyperlink(smtpSite.site_name, smtpSite.site_id)
          : ""}{" "}
        |{" "}
        {createCameraHyperlink(
          selectedRowSMTP.camera_name,
          smtpSite.site_id,
          selectedRowSMTP.camera_id
        )}{" "}
      </p>
      <div className="flex pt-[20px] pl-[10px]">
        <div>
          {!fetchingFilteredDataSMTP && (
            <div>
              <div>
                <div className={!navBarCollapsed ? "w-[745px]" : "w-[815px]"}>
                  <SMTPTable
                    order={order}
                    orderBy={orderBy}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                  />
                </div>
                {loadingAdditionalDataSMTP && (
                  <div className="relative pt-[5px]">
                    <div className="relative left-[10px]">
                      <LoadingSpinner />
                    </div>
                    <p className="absolute left-[58px] top-[7px] font-mulish text-actuate-orange">
                      Loading Additional Data
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="w-[660px]">
            <div className="w-[660px]">
              {!videoClipLoadingSMTP && (
                <div>
                  <div className="absolute left-[760px] top-[200px] z-10">
                    <OrangeTextButton
                      onClick={() => {
                        handleArrowButtonClickSMTP(
                          smtpData,
                          filteredData,
                          selectedRowSMTP,
                          "back",
                          setSelectedRowSMTP,
                          setSmtpData,
                          setVideoClipLoadingSMTP,
                          navigate,
                          order,
                          orderBy,
                          getVideoURLSMTP,
                          () =>
                            removeClipsIdParamsFromUrl(
                              setSearchParams,
                              searchParams
                            )
                        );
                      }}
                      text={
                        <ArrowBackIosIcon fontSize="large" id="BackButton" />
                      }
                      disabled={
                        filteredData.length === 0 ||
                        filteredData.findIndex(
                          (item: any) =>
                            item.clip_id === selectedRowSMTP.clip_id
                        ) === 0
                      }
                    />
                  </div>
                  <div className="absolute left-[1270px] top-[200px] z-10">
                    <OrangeTextButton
                      onClick={() => {
                        handleArrowButtonClickSMTP(
                          smtpData,
                          filteredData,
                          selectedRowSMTP,
                          "forward",
                          setSelectedRowSMTP,
                          setSmtpData,
                          setVideoClipLoadingSMTP,
                          navigate,
                          order,
                          orderBy,
                          getVideoURLSMTP,
                          () =>
                            removeClipsIdParamsFromUrl(
                              setSearchParams,
                              searchParams
                            )
                        );
                      }}
                      text={
                        <ArrowForwardIosIcon
                          fontSize="large"
                          id="forwardButton"
                        />
                      }
                      disabled={
                        filteredData.length === 0 ||
                        filteredData.findIndex(
                          (item: any) =>
                            item.clip_id === selectedRowSMTP.clip_id
                        ) ===
                          filteredData.length - 1
                      }
                    />
                  </div>
                  {selectedRowSMTP.armed && (
                    <div className="pl-[65px]">
                      <div className="pb-[10px]">
                        <ShareClipUrlButton tab="smtp" selectedRow={selectedRowSMTP} />
                      </div>
                      <SMTPPhotoSlider />
                      <div className="pt-[10px] pb-[10px]">
                        <AlertsTableSMTP />
                      </div>
                    </div>
                  )}
                  {!selectedRowSMTP.armed && (
                    <div className="absolute left-[785px] top-[190px] text-center w-[500px]">
                      <div className="pb-[10px]">
                        <ShareClipUrlButton tab="smtp" selectedRow={selectedRowSMTP} />
                      </div>
                      <p className="font-mulish text-[22px]">
                        Site was not armed.
                      </p>
                      <p className="font-mulish text-[22px]">
                        No files to display.
                      </p>
                    </div>
                  )}
                </div>
              )}
              <div>
                {videoClipLoadingSMTP && (
                  <div className="absolute left-[785px] top-[190px] text-center w-[500px]">
                    <ThemeProvider theme={theme}>
                      <div>
                        <CircularProgress color="primary" />
                      </div>
                      <br></br>
                      <p className="font-mulish text-[20px]">Loading...</p>
                    </ThemeProvider>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
